(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/tickets-table/tickets-table.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/tickets-table/tickets-table.js');
"use strict";

const {
  TicketItem,
  Sum
} = svs.ticket_partner.sharedComponents.ticketsTable.components;
const {
  Table,
  TableRow,
  TableBody,
  TableHeader,
  TableHead
} = svs.ui.reactTable;
const {
  NAME,
  PRICE,
  COUNT,
  TOTAL,
  SUM,
  MAXUMUM_COUNT,
  MAXIMUM_COUNT_ERROR_MESSAGE
} = svs.ticket_partner.constants.copy.TICKETS_TABLE;
const {
  ControlGroup,
  FormContext
} = svs.ui.reactForm;
const SUM_NAME = 'sum';
const TicketsTable = _ref => {
  let {
    cmsArticles,
    articles,
    handleOnChange,
    isEditable,
    infoMessage,
    maximumCount = MAXUMUM_COUNT,
    maximumCountErrorMessage = MAXIMUM_COUNT_ERROR_MESSAGE,
    minimumAmount = SUM.MINIMUM_AMOUNT,
    minimumAmountErrorMessage = SUM.MINIMUM_AMOUNT_ERROR_MESSAGE
  } = _ref;
  const validateSum = (event, value) => {
    const isValidSum = parseInt(value, 10) >= minimumAmount;
    const hasValue = value > 0;
    let isValid = hasValue && isValidSum;
    let currentErrorMessage = '';
    if (!isValidSum) {
      currentErrorMessage = minimumAmountErrorMessage;
    }
    if (event === 'onBlur') {
      isValid = isValidSum;
      if (value === '' || value === 0) {
        isValid = true;
        currentErrorMessage = '';
      }
    }
    return {
      errorMessage: currentErrorMessage,
      isValid,
      name: SUM_NAME
    };
  };
  const validateTotalCount = (event, value) => {
    const isValidCount = parseInt(value, 10) <= maximumCount;
    const isZeroCount = parseInt(value, 10) === 0;
    const hasValue = value > 0;
    let isValid = hasValue && isValidCount;
    let currentErrorMessage = '';
    if (isZeroCount) {
      currentErrorMessage = minimumAmountErrorMessage;
    }
    if (!isValidCount) {
      currentErrorMessage = maximumCountErrorMessage;
    }
    if (event === 'onBlur') {
      isValid = isValidCount;
      if (value === '' || value === 0) {
        isValid = true;
        currentErrorMessage = '';
      }
    }
    return {
      errorMessage: currentErrorMessage,
      isValid,
      name: SUM_NAME
    };
  };
  const sum = _.values(articles).reduce((acc, currentArticle) => acc + currentArticle.count * currentArticle.price, 0) || 0;
  const totalCount = _.values(articles).reduce((acc, currentArticle) => acc + (parseInt(currentArticle.count, 10) || 0), 0) || 0;
  const validate = event => {
    const totalCountResult = validateTotalCount(event, totalCount);
    if (totalCountResult.isValid) {
      return validateSum(event, sum);
    }
    return totalCountResult;
  };
  return React.createElement(FormContext.Consumer, null, _ref2 => {
    var _form$SUM_NAME;
    let {
      form,
      handleBlur,
      handleChange,
      register
    } = _ref2;
    return React.createElement(ControlGroup, {
      errorMessage: (_form$SUM_NAME = form[SUM_NAME]) === null || _form$SUM_NAME === void 0 ? void 0 : _form$SUM_NAME.errorMessage,
      hasError: form[SUM_NAME] && !form[SUM_NAME].isValid,
      infoMessage: infoMessage,
      v2: true
    }, React.createElement(Table, {
      large: true,
      striped: true
    }, React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableHeader, null, NAME), React.createElement(TableHeader, null, PRICE), React.createElement(TableHeader, null, COUNT), React.createElement(TableHeader, null, TOTAL))), React.createElement(TableBody, null, cmsArticles.map(article => {
      const articleCount = articles[article.ticketId] && articles[article.ticketId].count;
      const shouldHide = articleCount === 0 && !isEditable;
      return shouldHide ? null : React.createElement(TicketItem, {
        article: article,
        articleCount: articleCount,
        articles: articles,
        handleOnBlur: () => {
          handleBlur({
            target: {
              name: SUM_NAME,
              value: sum
            }
          });
        },
        handleOnChange: (e, article) => {
          handleChange({
            target: {
              name: SUM_NAME,
              value: sum
            }
          });
          handleOnChange(e, article);
        },
        isEditable: isEditable,
        key: article.ticketId,
        maximumCount: maximumCount
      });
    }), React.createElement(Sum, {
      articles: articles
    }))), React.createElement("input", {
      hidden: true,
      readOnly: true,
      ref: register(SUM_NAME, validate),
      value: sum
    }));
  });
};
svs.ticket_partner.sharedComponents.ticketsTable.TicketsTable = TicketsTable;

 })(window);